import { createSelector } from '@reduxjs/toolkit'

const getState = state => state.recents
const getMap = state => getState(state).map

export const getFetchingInProgress = state => getState(state).fetchingInProgress
export const getSharingUpdateInProgress = state => getState(state).sharingUpdateInProgress
export const getHasMore = state => getState(state).hasMore
export const getNextPageStartId = state => getState(state).nextPageStartId
export const getSessions = createSelector(getMap, map => Object.values(map).sort((a, b) => b.timestamp - a.timestamp))
export const getSession = sessionId => state => getMap(state)[sessionId]
export const getPlayingRecording = state => getState(state).playingRecording
